module.exports = __webpack_public_path__ + "img/197.6021b679.png";